"use client"

import FormApply from "@/(admin)/modules/ui-builder/config/themes/tamda-one/Career/components/FormApply"
import { getFixedT } from "@/languages/i18n"
import { CareerListResponseDataItem } from "@/types/codegen/data-contracts"

type JobDetailProps = {
  data: CareerListResponseDataItem
  locale: string
}

const JobDetail: React.FC<JobDetailProps> = ({ data, locale }) => {
  const t = getFixedT(locale)
  if (!data) return null

  return (
    <div className="mt-5 sm:mt-6 grid grid-cols-1 sm:grid-cols-12 bg-[#f5f5f5] p-5 sm:p-10">
      <div className="sm:col-span-7 sm:px-[15px] detail">
        <div className="prose download-form max-w-none" dangerouslySetInnerHTML={{ __html: data.attributes?.detail || "" }} />
      </div>

      <div className="sm:col-span-5 px-[15px] mt-10 sm:mt-0">
        <h4 className="mb-[15px] text-xl leading-[29px] sm:text-3xl sm:leading-[30px] font-black text-[#212529]">
          {t("Apply for")}&nbsp;
          {data.attributes?.position}
        </h4>
        <FormApply jobDetail={data} locale={locale} />
      </div>
    </div>
  )
}

export default JobDetail
